import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Mi tre amas homojn.
    </p>

    <p class="mb-3">
      Eĉ ne scias, de kie aperis ĉe mi tiu amo; eble, mi jam naskiĝis kun ĝi.
    </p>

    <p class="mb-5">
      Kiam mi vidas tiujn gigantojn, rozkolorajn, eltiritajn supren, kun haroj surpinte, min kaptas tia tenero! 
      Ili tute ne ŝajnas al mi monstroj-kripluloj; male, mi pli kaj pli certiĝas, ke neniu sur la Tero estas pli bela ol ili. <br/>
      Kaj se mi, domaĝe, ne povas esti kiel iil, do almenaŭ mi volas fari ion bonan por ili, montri iamaniere mian amon, esprimi min… 
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      - Ĉu vi rimarkis, kiel kondutas tiu porketo № 35-b-07? Ŝi konstante trafas sub miajn manojn en la komuna kaĝego, eĉ kiam mi preteriras sen furaĝo.
    </p>

    <p class="mb-5">
      - Nu do, prenu ŝin por la sekva eksperimento. Pli facilas kapti, pli facilas observi…
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      Ho ĝojo, oni rimarkis min! LI MEM prenis min je brakoj, portis ien… Min metis en apartan kaĝon, sed mi ne enuas. 
      Ja ĉi tie ĉirkaŭe estas ĉiam HOMOJ, kaj mi povas vidi, aŭdi ilin…
    </p>

    <p class="mb-5">
      Ilian lingvon mi jam pli bone komprenas, kaj rimarkas, ke ankaŭ ili ekvolis kompreni min. Jam farita estas la unua paŝo: ili atentis min, alproksimigis min al si. <br/>
      Nun endas nur klarigi al ili tion, kion mi volas diri – kaj la baro de nekompreno inter specioj estos detruita. La homoj eklernos kompreni la lingvon de animaloj, same kiel mi eklernis kompreni la homan lingvon. Nur ne forlasu min, priatentu min, penu kompreni min! Ja ne per vortoj mi parolos, sed ni kune kreos komunan psikan kampon; kaj kune kun mi homoj malfermos por si novan mondon, grandegan, senliman mondon de la Naturo, kaj ĉio vivanta unuiĝos fin-fine en komuna konscio kaj fariĝos potenca forto. Ne batalos ĉiu specio por sia vivo aparte: kune, nur kune ni konservos nian vivon kaj la tutan vivon sur la Tero!
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      - Nu kiel, ĉu vi prenis tiun porketon al eksperimento?
    </p>

    <p class="mb-5">
      - Jam delonge. 
      Tia kurioza ŝi estis: mi observis laŭ ŝi la sumigan efekton de rigora priradiado kaj hepatito; do imagu, eĉ antaŭ la morto ŝi lekis miajn manojn. Kiaj stultaj estas tiuj bestoj! 
      Tial oni ne bedaŭras ilin, kiam ili pereas pro la gloro de scienco. 
      Kaj krome, mi ricevis sur ŝi kelkajn valorajn donitaĵojn por la doktora tezo. 
      Ŝi servis al homoj, kia honoro al bestaĉo!
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      Sed kiam la rigora priradiado reale ĉirkaŭprenis la tutan Teron, saviĝis nek homoj, nek bestoj. 
      Ĉio vivanta, disigita kaj enfermita en sia propra ĉelo, pereis pounuope.
    </p>
    
    <p class="mb-3">
      Ruiniĝis montoj, sekiĝis maroj. 
      Rubikono estis trapasita, la kriza momento, kiam la Ĉio Vivanta povis unuiĝi, restis delonge for.
    </p>
    `
  )
}

const itemName = {
  esp: 'Io pri amo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;